<template>
  <b-card no-body style="border-color: #1a7696;">
    <div style="background-color: #20a8d8; color: white;" class="card-smallHeader card-header-action" v-b-toggle.collapse-droit-assure>
                  <span><b>Droit Assuré·e</b></span><span class="text-danger font-weight-bold ml-4">{{ refus }}</span>
      <div class="card-header-actions">
              <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
        <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
      </div>
    </div>
    <b-collapse id="collapse-droit-assure" class="m-3 pl-1 pr-1" v-model="showDroitAssure" :class="showDroitAssure ? null : 'collapsed'">
      <b-row class="pb-2">
        <b-col sm="6" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader">
              <span><b-badge variant="warning" class="mr-2">1</b-badge> <b>Couverture prévoyance</b></span>
            </div>
            <b-card-text class="p-1">
              <b-form-group>
                <template slot="label"><b>L'assuré remplit-il les conditions pour bénéficier du contrat de prévoyance ?</b></template>
                <b-form-radio-group
                  id="radio-group-2-1"
                  v-model="myData.is_elligible_contrat_prevoyance"
                  name="radio-elligible"
                  :disabled="isDisabled('is_elligible_contrat_prevoyance')"
                >
                  <b-form-radio value="true">Oui</b-form-radio>
                  <b-form-radio value="false">Non</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group>
                <template slot="label"><b>L'assuré bénéficiait-il de la portabilité ?</b></template>
                <b-form-radio-group
                  id="radio-group-2-2"
                  v-model="myData.has_portabilite"
                  name="radio-has_portabilite"
                  :disabled="isDisabled('has_portabilite')"
                >
                  <b-form-radio value="true">Oui</b-form-radio>
                  <b-form-radio value="false">Non</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group>
                <template slot="label"><b>L'assuré était-il en suspension du contrat de travail ou bénéficiait-il d'un accord sénior ?</b></template>
                <b-form-radio-group
                  id="radio-group-2-3"
                  v-model="myData.suspention_contrat"
                  name="radio-suspention_contrat"
                  :disabled="isDisabled('suspention_contrat')"
                >
                  <b-form-radio value="tp">Oui à temps partiel</b-form-radio>
                  <b-form-radio value="tc">Oui à temps complet</b-form-radio>
                  <b-form-radio value="non">Non</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group>
                <template slot="label"><b>Avait-il souscrit à l'option maintien des garanties décès ?</b></template>
                <b-form-radio-group
                  id="radio-group-2-4"
                  v-model="myData.has_option_maintien_garantie"
                  name="radio-has_option_maintien_garantie"
                  :disabled="isDisabled('has_option_maintien_garantie')"
                >
                  <b-form-radio value="true">Oui</b-form-radio>
                  <b-form-radio value="false">Non</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <span class="text-danger font-weight-bold" style="font-size: 1.3em;">{{ joindreBA }}</span>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col sm="6" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0" v-if="showBloc3">
            <div class="card-smallHeader">
              <span><b-badge variant="warning" class="mr-2">2</b-badge> <b>Situation de l'assuré au Décès</b></span>
            </div>
            <b-card-text class="p-1">
              <b-form-group>
                <template slot="label"><b>L'assuré était-il toujours salarié ?</b></template>
                <b-form-radio-group
                  id="radio-group-3-1"
                  v-model="myData.was_salarie"
                  name="radio-was_salarie"
                  :disabled="isDisabled('was_salarie')"
                >
                  <b-form-radio value="true">Oui</b-form-radio>
                  <b-form-radio value="false">Non</b-form-radio>
                </b-form-radio-group>
                <div class="pl-4">
                  <span class="mr-2"><b><i>Si non, indiquer la date de RUPC</i></b></span><b-form-input class="d-inline-block w-auto" type="date" v-model="myData.date_rupc" :disabled="isDisabled('date_rupc')"></b-form-input>
                </div>
              </b-form-group>
              <b-form-group>
                <template slot="label"><b>L'assuré avait-il un dossier en cours à la date du décès ?</b></template>
                <b-form-radio-group
                  id="radio-group-3-2"
                  v-model="myData.had_dossier_en_cours"
                  name="radio-had_dossier_en_cours"
                  :disabled="isDisabled('had_dossier_en_cours')"
                >
                  <b-form-radio value="true">Oui</b-form-radio>
                  <b-form-radio value="false">Non</b-form-radio>
                </b-form-radio-group>
                <div class="pl-4">
                  <span class="mr-2"><b><i>Si oui, préciser :</i></b></span>
                  <b-form-group>
                    <b-form-radio-group
                      id="radio-group-3-3"
                      v-model="myData.type_dossier_en_cours"
                      name="radio-type_dossier_en_cours"
                      :disabled="isDisabled('type_dossier_en_cours') || disablePrecisionDossierEnCours"
                      class="mb-1"
                    >
                      <b-form-radio value="ij">IJ</b-form-radio>
                      <b-form-radio value="inval-1-2">Inval 1ère / 2ème</b-form-radio>
                      <b-form-radio value="inval-3">Inval 3ème</b-form-radio>
                    </b-form-radio-group>
                    <span class="mr-2 d-inline-block" style="width: 150px;">Date fait générateur</span><b-form-input class="d-inline-block w-auto" type="date" v-model="myData.date_fait_generateur" :disabled="isDisabled('date_fait_generateur') || disablePrecisionDossierEnCours"></b-form-input><br>
                    <span class="mr-2 d-inline-block" style="width: 150px;">Dernier jour payé</span><b-form-input class="d-inline-block w-auto" type="date" v-model="myData.date_dernier_jour_paye" :disabled="isDisabled('date_dernier_jour_paye') || disablePrecisionDossierEnCours"></b-form-input>
                  </b-form-group>
                </div>
              </b-form-group>
              <b-form-group>
                <template slot="label"><b>Si inval. 3ème catégorie, le capital IAD a-t-il été versé ?</b></template>
                <b-form-radio-group
                  id="radio-group-3-4"
                  v-model="myData.has_capital_iad_verse"
                  name="radio-has_capital_iad_verse"
                  :disabled="isDisabled('has_capital_iad_verse') || disableRadioCapitalIad"
                >
                  <b-form-radio value="true">Oui</b-form-radio>
                  <b-form-radio value="false">Non</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <span class="text-danger font-weight-bold" style="font-size: 1.3em;">{{ refus }}</span>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col sm="6" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0" v-if="showBloc4">
            <div class="card-smallHeader">
              <span><b-badge variant="warning" class="mr-2">3</b-badge> <b>Mise à jour NSI</b></span>
            </div>
            <b-card-text class="p-1">
              <b-form-group class="mb-0">
                <template slot="label"><b>Le dossier est-il à jour des règlements ?</b></template>
                <b-form-radio-group
                  id="radio-group-4-1"
                  v-model="myData.is_reglement_a_jour"
                  name="radio-is_reglement_a_jour"
                  :disabled="isDisabled('is_reglement_a_jour')"
                >
                  <b-form-radio value="true">Oui</b-form-radio>
                  <b-form-radio value="false">Non</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <div class="pl-4">
                <span class="mr-2"><b><i>Si non, préciser :</i></b></span>
                <b-form-group>
                  <b-form-checkbox-group
                    id="stacked-checkbox-group"
                    v-model="myData.precision_non_a_jour"
                    name="checkbox-dossier-non-a-jour"
                    :disabled="isDisabled('precision_non_a_jour') || disablePrecisionReglementAJour"
                    stacked
                  >
                    <b-form-checkbox value="complement_notaire">Paiement complémentaire à faire au notaire</b-form-checkbox>
                    <b-form-checkbox value="complement_employeur">Paiement complémentaire à faire à l'employeur</b-form-checkbox>
                    <b-form-checkbox value="indu_notaire">Indu à réclamer au notaire</b-form-checkbox>
                    <b-form-checkbox value="indu_employeur">Indu à réclamer à l'employeur</b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
              <b-form-group>
                <template slot="label"><b>La date du fait générateur est-elle à enregistrer dans NSI ?</b></template>
                <b-form-radio-group
                  id="radio-group-4-2"
                  v-model="myData.is_fait_generateur_a_enregistrer_nsi"
                  name="radio-is_fait_generateur_a_enregistrer_nsi"
                  :disabled="isDisabled('is_fait_generateur_a_enregistrer_nsi')"
                >
                  <b-form-radio value="true">Oui</b-form-radio>
                  <b-form-radio value="false">Non</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <span class="mr-2 d-inline-block"><b>Numéro évènement décès NSI : </b></span><b-form-input class="d-inline-block w-auto" type="number" v-model="myData.numero_evenement_nsi" :disabled="isDisabled('numero_evenement_nsi')"></b-form-input>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col sm="6" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0" v-if="showBloc5">
            <div class="card-smallHeader">
              <span><b-badge variant="warning" class="mr-2">4</b-badge> <b>Situation contractuelle</b></span>
            </div>
            <b-card-text class="p-1">
              <span class="d-inline-block" style="width: 125px;"><b>Numéro de SIRET :</b></span><b-form-input class="d-inline-block ml-2 mr-1" style="width: 200px;" type="text" v-model="myData.siren_employeur" placeholder="SIREN" :disabled="isDisabled('siren_employeur')"></b-form-input>
              <b-form-input class="d-inline-block" style="width: 80px;" type="text" v-model="myData.nic_employeur" placeholder="NIC" :disabled="isDisabled('nic_employeur')"></b-form-input>
              <b class="d-block">Contrats (Base + Optionnel)</b>
              <span class="d-inline-block" style="width: 125px;">Base :</span>
              <b-form-input class="d-inline-block ml-2 mr-1" style="width: 200px;" type="text" v-model="myData.numero_contrat_base" placeholder="N° contrat base" :disabled="isDisabled('numero_contrat_base')"></b-form-input>
              <b-form-select class="d-inline-block" style="width: 300px;" v-model="myData.famille_produit_id_contrat_base" :disabled="isDisabled('famille_produit_id_contrat_base')" :options="produitOptions">
                <template v-slot:first>
                  <b-form-select-option :value="null"><strong>-- Choisir un produit pour la base --</strong></b-form-select-option>
                </template>
              </b-form-select>
              <br>
              <span class="d-inline-block" style="width: 125px;">Option :</span>
              <b-form-input class="d-inline-block ml-2 mr-1" style="width: 200px;" type="text" v-model="myData.numero_contrat_option" placeholder="N° contrat option" :disabled="isDisabled('numero_contrat_option')"></b-form-input>
              <b-form-select class="d-inline-block" style="width: 300px;" v-model="myData.famille_produit_id_contrat_option" :disabled="isDisabled('famille_produit_id_contrat_option')" :options="produitOptions">
                <template v-slot:first>
                  <b-form-select-option :value="null"><strong>-- Choisir un produit pour l'option --</strong></b-form-select-option>
                </template>
              </b-form-select>
              <br>
              <span class="d-inline-block" style="width: 125px;">Option 2 :</span>
              <b-form-input class="d-inline-block ml-2 mr-1" style="width: 200px;" type="text" v-model="myData.numero_contrat_option2" placeholder="N° contrat option" :disabled="isDisabled('numero_contrat_option2')"></b-form-input>
              <b-form-select class="d-inline-block" style="width: 300px;" v-model="myData.famille_produit_id_contrat_option2" :disabled="isDisabled('famille_produit_id_contrat_option2')" :options="produitOptions">
                <template v-slot:first>
                  <b-form-select-option :value="null"><strong>-- Choisir un produit pour l'option 2 --</strong></b-form-select-option>
                </template>
              </b-form-select>
              <b-form-group>
                <template slot="label"><b>Statut de l'assuré :</b></template>
                <b-form-radio-group
                  id="radio-group-5-1"
                  v-model="myData.statut_assure"
                  name="radio-statut_assure"
                  :disabled="isDisabled('statut_assure')"
                >
                  <b-form-radio value="cadre">Cadre</b-form-radio>
                  <b-form-radio value="non_cadre">Non cadre</b-form-radio>
                  <b-form-radio value="th">TH</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group>
                <template slot="label"><b>Bénéficiait-il d'un contrat TB Médéric ?</b></template>
                <b-form-radio-group
                  id="radio-group-5-1"
                  v-model="myData.has_tb_mederic"
                  name="radio-has_tb_mederic"
                  :disabled="isDisabled('has_tb_mederic')"
                >
                  <b-form-radio value="true">Oui</b-form-radio>
                  <b-form-radio value="false">Non</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group class=" d-inline-block">
                <template slot="label"><b>Avait-il plusieurs employeurs ?</b></template>
                <b-form-radio-group
                  id="radio-group-5-1"
                  v-model="myData.is_multi_siren"
                  name="radio-is_multi_siren"
                  :disabled="isDisabled('is_multi_siren')"
                >
                  <b-form-radio value="true">Oui</b-form-radio>
                  <b-form-radio value="false">Non</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-button class="button d-inline-block" variant="success" v-if="showButtonAddEmployeur" v-b-modal.modal-add-employeur><i class="fa fa-plus"></i> Ajouter un employeur</b-button>
              <b-card class="w-100 card-employeur" v-for="(employeur,id) in myData.decesEmployeurs" :key="id">
                <i class="fa fa-trash fa-1_5x text-danger clickable float-right" @click="removeEmployeur(id)"></i>
                <span class="d-inline-block" style="width: 130px;"><b>Numéro de SIRET :</b></span><b-form-input class="d-inline-block ml-2 mr-1" style="width: 200px;" type="text" v-model="myData.decesEmployeurs[id].siren" placeholder="SIREN" :disabled="isDisabled('siren_employeur')"></b-form-input>
                <b-form-input class="d-inline-block" style="width: 80px;" type="text" v-model="myData.decesEmployeurs[id].nic" placeholder="NIC" :disabled="isDisabled('nic_employeur')"></b-form-input>
                <b class="d-block mt-2">Contrats (Base + Optionnel)</b>
                <span class="d-inline-block" style="width: 130px;">Base :</span>
                <b-form-input class="d-inline-block ml-2 mr-1" style="width: 200px;" type="text" v-model="myData.decesEmployeurs[id].numero_contrat_base" placeholder="N° contrat base" :disabled="isDisabled('numero_contrat_base')"></b-form-input> Produit :
                <b-form-select class="d-inline-block" style="width: 300px;" v-model="myData.decesEmployeurs[id].famille_produit_id_contrat_base" :disabled="isDisabled('famille_produit_id_contrat_base')" :options="produitOptions">
                  <template v-slot:first>
                    <b-form-select-option :value="null"><strong>-- Choisir un produit pour la base --</strong></b-form-select-option>
                  </template>
                </b-form-select>
                <br>
                <span class="d-inline-block" style="width: 130px;">Option :</span>
                <b-form-input class="d-inline-block ml-2 mr-1" style="width: 200px;" type="text" v-model="myData.decesEmployeurs[id].numero_contrat_option" placeholder="N° contrat option" :disabled="isDisabled('numero_contrat_option')"></b-form-input> Produit :
                <b-form-select class="d-inline-block" style="width: 300px;" v-model="myData.decesEmployeurs[id].famille_produit_id_contrat_option" :disabled="isDisabled('famille_produit_id_contrat_option')" :options="produitOptions">
                  <template v-slot:first>
                    <b-form-select-option :value="null"><strong>-- Choisir un produit pour l'option --</strong></b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-group class="mt-2">
                  <template slot="label"><b>Statut de l'assuré :</b></template>
                  <b-form-radio-group
                    :id="'radio-group-5-2-'+id"
                    v-model="myData.decesEmployeurs[id].statut_assure"
                    :name="'radio-statut_assure-'+id"
                    :disabled="isDisabled('statut_assure')"
                  >
                    <b-form-radio value="cadre">Cadre</b-form-radio>
                    <b-form-radio value="non_cadre">Non cadre</b-form-radio>
                    <b-form-radio value="th">TH</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group class="mb-0">
                  <template slot="label"><b>Bénéficiait-il d'un contrat TB Médéric ?</b></template>
                  <b-form-radio-group
                    :id="'radio-group-5-3-'+id"
                    v-model="myData.decesEmployeurs[id].has_tb_mederic"
                    :name="'radio-has_tb_mederic-'+id"
                    :disabled="isDisabled('has_tb_mederic')"
                  >
                    <b-form-radio value="true">Oui</b-form-radio>
                    <b-form-radio value="false">Non</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
                <i class="fa fa-save fa-1_5x text-primary clickable float-right" @click="editEmployeur(employeur, id)"></i>
              </b-card>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0" v-if="showBloc6">
            <div class="card-smallHeader">
              <span><b-badge variant="warning" class="mr-2">5</b-badge> <b>Vérification exclusions</b></span>
            </div>
            <b-card-text class="p-1">
              <b-form-group class="mb-0">
                <template slot="label"><b>Les clauses d'exclusion prévues par le contrat sont-elles avérées ?</b></template>
                <b-form-radio-group
                  id="radio-group-6-1"
                  v-model="myData.is_clauses_exclusion_averees"
                  name="radio-is_clauses_exclusion_averees"
                  :disabled="isDisabled('is_clauses_exclusion_averees')"
                >
                  <b-form-radio value="true">Oui</b-form-radio>
                  <b-form-radio value="false">Non</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <span class="text-danger font-weight-bold" style="font-size: 1.3em;">{{ refus }}</span>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col sm="6" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0" v-if="showBloc7">
            <div class="card-smallHeader">
              <span><b-badge variant="warning" class="mr-2">6</b-badge> <b>Vérification REC</b></span>
            </div>
            <b-card-text class="p-1">
              <b-form-group class="mb-0">
                <template slot="label"><b>Le contrat est-il résilié ?</b></template>
                <b-form-radio-group
                  id="radio-group-7-1"
                  v-model="myData.is_contrat_resilie"
                  name="radio-is_contrat_resilie"
                  :disabled="isDisabled('is_contrat_resilie')"
                >
                  <b-form-radio value="true">Oui</b-form-radio>
                  <b-form-radio value="false">Non</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <div v-if="contratResilie">
                <div class="pl-4 full-width">
                  <span class="mr-2"><b><i>Si oui, préciser le motif :</i></b></span>
                  <b-form-group>
                    <b-form-radio-group
                      id="radio-group-7-2"
                      v-model="myData.motif_resiliation"
                      name="radio-motif_resiliation"
                      :disabled="isDisabled('motif_resiliation')"
                      stacked
                    >
                      <b-form-radio value="fusion">Fusion/Absorption</b-form-radio>
                      <b-form-radio value="demande_souscripteur">Demande contractuelle du souscripteur</b-form-radio>
                      <b-form-radio value="regroupement">Regroupement de gestion</b-form-radio>
                      <b-form-radio class="d-inline-block" value="autre">Autre : </b-form-radio><b-form-input class="d-inline-block ml-2 w-auto" type="text" v-model="myData.motif_resiliation_autre" :disabled="isDisabled('motif_resiliation')"></b-form-input>
                    </b-form-radio-group>
                  </b-form-group>
                </div>
                <b-form-group>
                  <template slot="label"><b>La fermeture a-t-elle été effectuée à niveau atteint ?</b></template>
                  <b-form-radio-group
                    id="radio-group-7-3"
                    v-model="myData.is_fermeture_effectuee_niveau_atteint"
                    name="radio-is_fermeture_effectuee_niveau_atteint"
                    :disabled="isDisabled('is_fermeture_effectuee_niveau_atteint')"
                  >
                    <b-form-radio value="true">Oui</b-form-radio>
                    <b-form-radio value="false">Non</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
                <div v-if="niveauAtteint">
                  <b-form-group>
                    <template slot="label"><b>Si oui, MEP nouveau contrat ?</b></template>
                    <b-form-radio-group
                      id="radio-group-7-4"
                      v-model="myData.is_mep_nouveau_contrat"
                      name="radio-is_mep_nouveau_contrat"
                      :disabled="isDisabled('is_mep_nouveau_contrat')"
                    >
                      <b-form-radio value="true">Oui</b-form-radio>
                      <b-form-radio value="false">Non</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                  <div v-if="nouveauContrat">
                    <b-form-group>
                      <template slot="label"><b>Si oui, préciser :</b></template>
                      <span class="d-inline-block" style="width: 120px;">Numéro de SIRET :</span><b-form-input class="d-inline-block ml-2 mr-1" style="width: 200px;" type="text" v-model="myData.siren_nouveau_contrat" placeholder="SIREN" :class="{hasError: errors.siren_nouveau_contrat !== ''}"></b-form-input>
                      <b-form-input class="d-inline-block" style="width: 80px;" type="text" v-model="myData.nic_nouveau_contrat" placeholder="NIC" @change="checkSiretNouveauContrat()" :class="{hasError: errors.siren_nouveau_contrat !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.siren_nouveau_contrat }}</span>
                      <b class="d-block">Contrats (Base + Optionnel)</b>
                      <span class="d-inline-block" style="width: 120px;">Base :</span>
                      <b-form-input class="d-inline-block ml-2 mr-1" style="width: 200px;" type="text" v-model="myData.numero_nouveau_contrat_base" placeholder="N° contrat base"></b-form-input>
                      <b-form-select class="d-inline-block" style="width: 300px;" v-model="myData.famille_produit_id_nouveau_contrat_base" :disabled="isDisabled('famille_produit_id_nouveau_contrat_base')" :options="produitOptions">
                        <template v-slot:first>
                          <b-form-select-option :value="null"><strong>-- Choisir un produit pour la base --</strong></b-form-select-option>
                        </template>
                      </b-form-select>
                      <br>
                      <span class="d-inline-block" style="width: 120px;">Option :</span>
                      <b-form-input class="d-inline-block ml-2 mr-1" style="width: 200px;" type="text" v-model="myData.numero_nouveau_contrat_option" placeholder="N° contrat option"></b-form-input>
                      <b-form-select class="d-inline-block" style="width: 300px;" v-model="myData.famille_produit_id_nouveau_contrat_option" :disabled="isDisabled('famille_produit_id_nouveau_contrat_base')" :options="produitOptions">
                        <template v-slot:first>
                          <b-form-select-option :value="null"><strong>-- Choisir un produit pour l'option --</strong></b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </div><!-- fin si oui à MEP nouveau contrat -->
                </div><!-- fin si oui à fermeture à niveau atteint -->
              </div><!-- fin si oui à contrat résilié -->
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-button class="float-right mt-2 mb-1 mr-1" variant="primary" @click="save()"><i class="fa fa-save"></i>
        Enregistrer
      </b-button>
    </b-collapse>

    <b-modal size="xl" centered id="modal-add-employeur" ref="modal-add-employeur" title="Renseigner les informations concernant l'employeur" no-close-on-backdrop no-close-on-esc hide-header-close>
      <span class="d-inline-block" style="width: 120px;">Numéro de SIRET :</span><b-form-input class="d-inline-block ml-2 mr-1" style="width: 200px;" type="text" v-model="siren_employeur" placeholder="SIREN" :disabled="isDisabled('siren_employeur')" :class="{hasError: errors.siren_employeur !== ''}"></b-form-input>
      <b-form-input class="d-inline-block" style="width: 80px;" type="text" v-model="nic_employeur" placeholder="NIC" :disabled="isDisabled('nic_employeur')" :class="{hasError: errors.siren_employeur !== ''}"></b-form-input>
      <span class="field-error">{{ errors.siren_employeur }}</span>
      <b class="d-block">Contrats (Base + Optionnel)</b>
      <span class="d-inline-block" style="width: 120px;">Base :</span>
      <b-form-input class="d-inline-block ml-2 mr-1" style="width: 200px;" type="text" v-model="numero_contrat_base" placeholder="N° contrat base" :disabled="isDisabled('numero_contrat_base')"></b-form-input>
      <b-form-select class="d-inline-block" style="width: 300px;" v-model="famille_produit_id_contrat_base" :disabled="isDisabled('famille_produit_id_contrat_base')" :options="produitOptions">
        <template v-slot:first>
          <b-form-select-option :value="null"><strong>-- Choisir un produit pour la base --</strong></b-form-select-option>
        </template>
      </b-form-select>
      <br>
      <span class="d-inline-block" style="width: 120px;">Option :</span>
      <b-form-input class="d-inline-block ml-2 mr-1" style="width: 200px;" type="text" v-model="numero_contrat_option" placeholder="N° contrat option" :disabled="isDisabled('numero_contrat_option')"></b-form-input>
      <b-form-select class="d-inline-block" style="width: 300px;" v-model="famille_produit_id_contrat_option" :disabled="isDisabled('famille_produit_id_contrat_option')" :options="produitOptions">
        <template v-slot:first>
          <b-form-select-option :value="null"><strong>-- Choisir un produit pour l'option --</strong></b-form-select-option>
        </template>
      </b-form-select>
      <b-form-group>
        <template slot="label"><b>Statut de l'assuré :</b></template>
        <b-form-radio-group
          id="radio-group-5-1"
          v-model="statut_assure"
          name="radio-statut_assure"
          :disabled="isDisabled('statut_assure')"
        >
          <b-form-radio value="cadre">Cadre</b-form-radio>
          <b-form-radio value="non_cadre">Non cadre</b-form-radio>
          <b-form-radio value="th">TH</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <b-form-group>
        <template slot="label"><b>Bénéficiait-il d'un contrat TB Médéric ?</b></template>
        <b-form-radio-group
          id="radio-group-5-1"
          v-model="has_tb_mederic"
          name="radio-has_tb_mederic"
          :disabled="isDisabled('has_tb_mederic')"
        >
          <b-form-radio value="true">Oui</b-form-radio>
          <b-form-radio value="false">Non</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModalAddEmployeur()">Annuler</button>
          <button type="button" @click="addEmployeur()" class="btn btn-primary"><i class="fa fa-save"></i>
            Enregistrer
          </button>
        </div>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
  import { isEmpty, checkSIRET, downloadFile, guardedFile } from '@/utils/fileHelper';

  export default {
    name: "AideGestion",
    data() {
      return {
        showBloc3: false,
        showBloc4: false,
        showBloc5: false,
        showBloc6: false,
        showBloc7: false,
        contratResilie: false,
        niveauAtteint: false,
        nouveauContrat: false,
        showButtonAddEmployeur: false,
        disableRadioCapitalIad: true,
        disablePrecisionDossierEnCours: true,
        disablePrecisionReglementAJour: true,
        joindreBA: '',
        refus: '',
        produitOptions: [],
        siren_employeur: '',
        nic_employeur: '',
        numero_contrat_base: '',
        numero_contrat_option: '',
        famille_produit_id_contrat_base: null,
        famille_produit_id_contrat_option: null,
        statut_assure: '',
        has_tb_mederic: '',
        myData: {
          is_elligible_contrat_prevoyance: '',
          has_portabilite: '',
          suspention_contrat: '',
          has_option_maintien_garantie: '',
          was_salarie: '',
          date_rupc: '',
          had_dossier_en_cours: '',
          type_dossier_en_cours: '',
          date_fait_generateur: '',
          date_dernier_jour_paye: '',
          has_capital_iad_verse: '',
          is_reglement_a_jour: '',
          precision_non_a_jour: [],
          is_fait_generateur_a_enregistrer_nsi: '',
          numero_evenement_nsi: '',
          is_multi_siren: '',
          is_clauses_exclusion_averees: '',
          is_contrat_resilie: '',
          motif_resiliation: '',
          motif_resiliation_autre: '',
          is_fermeture_effectuee_niveau_atteint: '',
          is_mep_nouveau_contrat: '',
          siren_nouveau_contrat: '',
          nic_nouveau_contrat: '',
          numero_nouveau_contrat_base: '',
          numero_nouveau_contrat_option: '',
          famille_produit_id_nouveau_contrat_base: null,
          famille_produit_id_nouveau_contrat_option: null,
          statut_assure: '',
          has_tb_mederic: '',
          siren_employeur: '',
          nic_employeur: '',
          numero_contrat_base: '',
          numero_contrat_option: '',
          numero_contrat_option2: '',
          famille_produit_id_contrat_base: null,
          famille_produit_id_contrat_option: null,
          famille_produit_id_contrat_option2: null,
          decesEmployeurs: {},
        },
        errors: {
          siren_employeur: '',
          siren_nouveau_contrat: ''
        },
        showDroitAssure: false,
      }
    },
    props: [
      'dossier',
      'traitements',
      'allFamillesProduits'
    ],
    watch: {
      myData: {
        handler: _.debounce(function (value) {
          this.$event.emit('editDossier', 'DroitAssure', value);
        }, 1000),
        deep: true,
      },
      'myData.is_elligible_contrat_prevoyance'() {
        if (this.myData.is_elligible_contrat_prevoyance === 'true') {
          this.showBloc3 = true;
        } else if (this.myData.is_elligible_contrat_prevoyance === 'false') {
          // Si on clique sur non, on cache les blocs suivants et on vide les input qui ont été rentrées
          this.showBloc3 = false;
          this.showBloc4 = false;
          this.showBloc5 = false;
          this.showBloc6 = false;
          this.showBloc7 = false;
          this.contratResilie = false;
          this.niveauAtteint = false;
          this.nouveauContrat = false;
          this.myData.has_portabilite = '';
          this.myData.suspention_contrat = '';
          this.myData.has_option_maintien_garantie = '';
          this.myData.was_salarie = '';
          this.myData.date_rupc = '';
          this.myData.had_dossier_en_cours = '';
          this.myData.type_dossier_en_cours = '';
          this.myData.date_fait_generateur = '';
          this.myData.date_dernier_jour_paye = '';
          this.myData.has_capital_iad_verse = '';
          this.myData.is_reglement_a_jour = '';
          this.myData.precision_non_a_jour = [];
          this.myData.is_fait_generateur_a_enregistrer_nsi = '';
          this.myData.numero_evenement_nsi = '';
          this.myData.is_multi_siren = '';
          this.myData.is_clauses_exclusion_averees = '';
          this.myData.is_contrat_resilie = '';
          this.myData.motif_resiliation = '';
          this.myData.motif_resiliation_autre = '';
          this.myData.is_fermeture_effectuee_niveau_atteint = '';
          this.myData.is_mep_nouveau_contrat = '';
          this.myData.siren_nouveau_contrat = '';
          this.myData.nic_nouveau_contrat = '';
          this.myData.numero_nouveau_contrat_base = '';
          this.myData.numero_nouveau_contrat_option = '';
          this.myData.famille_produit_id_nouveau_contrat_base = null;
          this.myData.famille_produit_id_nouveau_contrat_option = null;
        }
      },
      'myData.has_option_maintien_garantie'() {
        if (this.myData.has_option_maintien_garantie === 'true') {
          this.joindreBA = 'Joindre le BA';
        } else {
          this.joindreBA = '';
        }
      },
      'myData.had_dossier_en_cours'() {
        if (this.myData.had_dossier_en_cours === 'false') {
          this.showBloc4 = true;
          this.disablePrecisionDossierEnCours = true;
          this.myData.type_dossier_en_cours = '';
          this.myData.date_fait_generateur = '';
          this.myData.date_dernier_jour_paye = '';
        } else if (this.myData.had_dossier_en_cours === 'true') {
          this.showBloc4 = false;
          this.disablePrecisionDossierEnCours = false;
        }
      },
      'myData.type_dossier_en_cours'() {
        if (this.myData.type_dossier_en_cours === 'ij' || this.myData.type_dossier_en_cours === 'inval-1-2') {
          this.showBloc4 = true;
          this.disableRadioCapitalIad = true;
          this.myData.has_capital_iad_verse = '';
        } else if (this.myData.type_dossier_en_cours === 'inval-3') {
          this.showBloc4 = false;
          this.disableRadioCapitalIad = false;
        } else if (this.myData.had_dossier_en_cours !== 'false') {
          this.showBloc4 = false;
        }
      },
      'myData.has_capital_iad_verse'() {
        if (this.myData.has_capital_iad_verse === 'false') {
          this.showBloc4 = true;
          this.refus = '';
        } else if (this.myData.has_capital_iad_verse === 'true') {
          // Si cette option est coché on affiche le message Refus et on cahche les blocs suivants en vidant les données
          this.refus = 'REFUS';
          this.showBloc4 = false;
          this.showBloc5 = false;
          this.showBloc6 = false;
          this.showBloc7 = false;
          this.contratResilie = false;
          this.niveauAtteint = false;
          this.nouveauContrat = false;
          this.myData.is_reglement_a_jour = '';
          this.myData.precision_non_a_jour = [];
          this.myData.is_fait_generateur_a_enregistrer_nsi = '';
          this.myData.numero_evenement_nsi = '';
          this.myData.is_multi_siren = '';
          this.myData.is_clauses_exclusion_averees = '';
          this.myData.is_contrat_resilie = '';
          this.myData.motif_resiliation = '';
          this.myData.motif_resiliation_autre = '';
          this.myData.is_fermeture_effectuee_niveau_atteint = '';
          this.myData.is_mep_nouveau_contrat = '';
          this.myData.siren_nouveau_contrat = '';
          this.myData.nic_nouveau_contrat = '';
          this.myData.numero_nouveau_contrat_base = '';
          this.myData.numero_nouveau_contrat_option = '';
          this.myData.famille_produit_id_nouveau_contrat_base = null;
          this.myData.famille_produit_id_nouveau_contrat_option = null;
        }
      },
      'myData.is_reglement_a_jour'() {
        if (this.myData.is_reglement_a_jour === 'false') {
          this.disablePrecisionReglementAJour = false;
        } else if (this.myData.is_reglement_a_jour === 'true') {
          this.disablePrecisionReglementAJour = true;
          this.myData.precision_non_a_jour = [];
        }
      },
      'myData.numero_evenement_nsi'() {
        if (!isEmpty(this.myData.numero_evenement_nsi)) {
          this.showBloc5 = true;
        } else {
          this.showBloc5 = false;
        }
      },
      'myData.is_multi_siren'() {
        if (this.myData.is_multi_siren === 'false') {
          this.showBloc6 = true;
          this.showBloc7 = true;
          this.showButtonAddEmployeur = false;
        } else if (this.myData.is_multi_siren === 'true') {
          this.showBloc6 = true;
          this.showBloc7 = true;
          this.showButtonAddEmployeur = true;
        }
      },
      'myData.is_clauses_exclusion_averees'() {
        if (this.myData.is_clauses_exclusion_averees === 'false') {
          this.showBloc7 = true;
          this.refus = '';
        } else if (this.myData.is_clauses_exclusion_averees === 'true') {
          // Si cette option est coché on affiche le message Refus et on cahche les blocs suivants en vidant les données
          this.refus = 'REFUS';
          this.showBloc7 = false;
          this.contratResilie = false;
          this.niveauAtteint = false;
          this.nouveauContrat = false;
          this.myData.is_contrat_resilie = '';
          this.myData.motif_resiliation = '';
          this.myData.motif_resiliation_autre = '';
          this.myData.is_fermeture_effectuee_niveau_atteint = '';
          this.myData.is_mep_nouveau_contrat = '';
          this.myData.siren_nouveau_contrat = '';
          this.myData.nic_nouveau_contrat = '';
          this.myData.numero_nouveau_contrat_base = '';
          this.myData.numero_nouveau_contrat_option = '';
          this.myData.famille_produit_id_nouveau_contrat_base = null;
          this.myData.famille_produit_id_nouveau_contrat_option = null;
        }
      },
      'myData.is_contrat_resilie'() {
        if (this.myData.is_contrat_resilie === 'true') {
          this.contratResilie = true;
        } else if (this.myData.is_contrat_resilie === 'false') {
          // On cache les autres questions et on vide les réponses qui ont pu être saisie dans la suite des inputs
          this.contratResilie = false;
          this.niveauAtteint = false;
          this.nouveauContrat = false;
          this.myData.motif_resiliation = '';
          this.myData.motif_resiliation_autre = '';
          this.myData.is_fermeture_effectuee_niveau_atteint = '';
          this.myData.is_mep_nouveau_contrat = '';
          this.myData.siren_nouveau_contrat = '';
          this.myData.nic_nouveau_contrat = '';
          this.myData.numero_nouveau_contrat_base = '';
          this.myData.numero_nouveau_contrat_option = '';
          this.myData.famille_produit_id_nouveau_contrat_base = null;
          this.myData.famille_produit_id_nouveau_contrat_option = null;
        }
      },
      'myData.is_fermeture_effectuee_niveau_atteint'() {
        if (this.myData.is_fermeture_effectuee_niveau_atteint === 'true') {
          this.niveauAtteint = true;
        } else if (this.myData.is_fermeture_effectuee_niveau_atteint === 'false') {
          // On cache les autres questions et on vide les réponses qui ont pu être saisie dans la suite des inputs
          this.niveauAtteint = false;
          this.nouveauContrat = false;
          this.myData.is_mep_nouveau_contrat = '';
          this.myData.siren_nouveau_contrat = '';
          this.myData.nic_nouveau_contrat = '';
          this.myData.numero_nouveau_contrat_base = '';
          this.myData.numero_nouveau_contrat_option = '';
          this.myData.famille_produit_id_nouveau_contrat_base = null;
          this.myData.famille_produit_id_nouveau_contrat_option = null;
        }
      },
      'myData.is_mep_nouveau_contrat'() {
        if (this.myData.is_mep_nouveau_contrat === 'true') {
          this.nouveauContrat = true;
        } else if (this.myData.is_mep_nouveau_contrat === 'false') {
          // On cache les autres questions et on vide les réponses qui ont pu être saisie dans la suite des inputs
          this.nouveauContrat = false;
          this.myData.siren_nouveau_contrat = '';
          this.myData.nic_nouveau_contrat = '';
          this.myData.numero_nouveau_contrat_base = '';
          this.myData.numero_nouveau_contrat_option = '';
          this.myData.famille_produit_id_nouveau_contrat_base = null;
          this.myData.famille_produit_id_nouveau_contrat_option = null;
        }
      },
    },
    computed: {
    },
    mounted() {
      // console.log(this.allFamillesProduits)
      this.setForm();
      this.produitOptions = _.sortBy(this.allFamillesProduits, ['text']);
    },
    methods: {
      setForm() {
        if (!isEmpty(this.dossier.fiche_deces)) {
          this.myData.is_elligible_contrat_prevoyance = this.dossier.fiche_deces.is_elligible_contrat_prevoyance === true ? 'true' : (this.dossier.fiche_deces.is_elligible_contrat_prevoyance === false ? 'false' : '');
          this.myData.has_portabilite = this.dossier.fiche_deces.has_portabilite === true ? 'true' : (this.dossier.fiche_deces.has_portabilite === false ? 'false' : '');
          this.myData.suspention_contrat = this.dossier.fiche_deces.suspention_contrat;
          this.myData.has_option_maintien_garantie = this.dossier.fiche_deces.has_option_maintien_garantie === true ? 'true' : (this.dossier.fiche_deces.has_option_maintien_garantie === false ? 'false' : '');
          this.myData.was_salarie = this.dossier.fiche_deces.was_salarie === true ? 'true' : (this.dossier.fiche_deces.was_salarie === false ? 'false' : '');
          this.myData.date_rupc = this.dossier.fiche_deces.date_rupc;
          this.myData.had_dossier_en_cours = this.dossier.fiche_deces.had_dossier_en_cours === true ? 'true' : (this.dossier.fiche_deces.had_dossier_en_cours === false ? 'false' : '');
          this.myData.type_dossier_en_cours = this.dossier.fiche_deces.type_dossier_en_cours;
          this.myData.date_fait_generateur = this.dossier.fiche_deces.date_fait_generateur;
          this.myData.date_dernier_jour_paye = this.dossier.fiche_deces.date_dernier_jour_paye;
          this.myData.has_capital_iad_verse = this.dossier.fiche_deces.has_capital_iad_verse === true ? 'true' : (this.dossier.fiche_deces.has_capital_iad_verse === false ? 'false' : '');
          this.myData.is_reglement_a_jour = this.dossier.fiche_deces.is_reglement_a_jour === true ? 'true' : (this.dossier.fiche_deces.is_reglement_a_jour === false ? 'false' : '');

          if (this.dossier.fiche_deces.has_paiement_complementaire_notaire) { this.myData.precision_non_a_jour.push('complement_notaire'); }
          if (this.dossier.fiche_deces.has_paiement_complementaire_employeur) { this.myData.precision_non_a_jour.push('complement_employeur'); }
          if (this.dossier.fiche_deces.has_indu_notaire) { this.myData.precision_non_a_jour.push('indu_notaire'); }
          if (this.dossier.fiche_deces.has_indu_employeur) { this.myData.precision_non_a_jour.push('indu_employeur'); }

          this.myData.is_fait_generateur_a_enregistrer_nsi = this.dossier.fiche_deces.is_fait_generateur_a_enregistrer_nsi === true ? 'true' : (this.dossier.fiche_deces.is_fait_generateur_a_enregistrer_nsi === false ? 'false' : '');
          this.myData.numero_evenement_nsi = this.dossier.fiche_deces.numero_evenement_nsi;
          this.myData.is_multi_siren = this.dossier.fiche_deces.is_multi_siren === true ? 'true' : (this.dossier.fiche_deces.is_multi_siren === false ? 'false' : '');
          this.myData.is_clauses_exclusion_averees = this.dossier.fiche_deces.is_clauses_exclusion_averees === true ? 'true' : (this.dossier.fiche_deces.is_clauses_exclusion_averees === false ? 'false' : '');
          this.myData.is_contrat_resilie = this.dossier.fiche_deces.is_contrat_resilie === true ? 'true' : (this.dossier.fiche_deces.is_contrat_resilie === false ? 'false' : '');
          this.myData.motif_resiliation = this.dossier.fiche_deces.motif_resiliation;
          this.myData.motif_resiliation_autre = this.dossier.fiche_deces.motif_resiliation_autre;
          this.myData.is_fermeture_effectuee_niveau_atteint = this.dossier.fiche_deces.is_fermeture_effectuee_niveau_atteint === true ? 'true' : (this.dossier.fiche_deces.is_fermeture_effectuee_niveau_atteint === false ? 'false' : '');
          this.myData.is_mep_nouveau_contrat = this.dossier.fiche_deces.is_mep_nouveau_contrat === true ? 'true' : (this.dossier.fiche_deces.is_mep_nouveau_contrat === false ? 'false' : '');
          this.myData.siren_nouveau_contrat = this.dossier.fiche_deces.siren_nouveau_contrat;
          this.myData.nic_nouveau_contrat = this.dossier.fiche_deces.nic_nouveau_contrat;
          this.myData.numero_nouveau_contrat_base = this.dossier.fiche_deces.numero_nouveau_contrat_base;
          this.myData.numero_nouveau_contrat_option = this.dossier.fiche_deces.numero_nouveau_contrat_option;
          this.myData.famille_produit_id_nouveau_contrat_base = this.dossier.fiche_deces.famille_produit_id_nouveau_contrat_base;
          this.myData.famille_produit_id_nouveau_contrat_option = this.dossier.fiche_deces.famille_produit_id_nouveau_contrat_option;
          this.myData.statut_assure = this.dossier.fiche_deces.statut_assure;
          this.myData.has_tb_mederic = this.dossier.fiche_deces.has_tb_mederic === true ? 'true' : (this.dossier.fiche_deces.has_tb_mederic === false ? 'false' : '');
          this.myData.siren_employeur = this.dossier.siren;
          this.myData.nic_employeur = this.dossier.nic;
          this.myData.numero_contrat_base = this.dossier.fiche_deces.numero_contrat_base;
          this.myData.numero_contrat_option = this.dossier.fiche_deces.numero_contrat_option;
          this.myData.numero_contrat_option2 = this.dossier.fiche_deces.numero_contrat_option2;
          this.myData.famille_produit_id_contrat_base = this.dossier.fiche_deces.famille_produit_id_contrat_base;
          this.myData.famille_produit_id_contrat_option = this.dossier.fiche_deces.famille_produit_id_contrat_option;
          this.myData.famille_produit_id_contrat_option2 = this.dossier.fiche_deces.famille_produit_id_contrat_option2;
          if (!isEmpty(this.dossier.deces_employeur)) {
            for (let employeur of this.dossier.deces_employeur) {
              this.myData.decesEmployeurs[employeur.id] = {
                siren: employeur.siren,
                nic: employeur.nic,
                numero_contrat_base: employeur.numero_contrat_base,
                numero_contrat_option: employeur.numero_contrat_option,
                famille_produit_id_contrat_base: employeur.famille_produit_id_base,
                famille_produit_id_contrat_option: employeur.famille_produit_id_option,
                statut_assure: employeur.statut_assure,
                has_tb_mederic: employeur.has_tb_mederic
              }
            }
          }
        }
      },
      isDisabled(field) {
        return this.$parent.$parent.$parent.isDisabled(field);
      },
      closeModalAddEmployeur() {
        this.clearErrorsAddEmployeur();
        this.$refs['modal-add-employeur'].hide();
        this.siren_employeur = '';
        this.nic_employeur = '';
        this.numero_contrat_base = '';
        this.numero_contrat_option = '';
        this.famille_produit_id_contrat_base = null;
        this.famille_produit_id_contrat_option = null;
        this.has_tb_mederic = '';
      },
      clearErrorsAddEmployeur() {
        this.errors.siren_employeur = '';
      },
      addEmployeur() {
        this.clearErrorsAddEmployeur();
        if (this.validateAddEmployeur()) {
          let self = this;
          let dataPost = {
            dossierId: this.dossier.id,
            siren_employeur: this.siren_employeur,
            nic_employeur: String(this.nic_employeur).padStart(5, '0'),
            numero_contrat_base: this.numero_contrat_base,
            numero_contrat_option: this.numero_contrat_option,
            famille_produit_id_base: this.famille_produit_id_contrat_base,
            famille_produit_id_option: this.famille_produit_id_contrat_option,
            statut_assure: this.statut_assure,
            has_tb_mederic: this.has_tb_mederic
          }
          this.$axios
            .post("/espaceGestion/dossier/employeur/add", dataPost)
            .then(response => {
              this.myData.decesEmployeurs[response.data.decesEmployeur.id] = {
                siren: response.data.decesEmployeur.siren,
                nic: response.data.decesEmployeur.nic,
                numero_contrat_base: response.data.decesEmployeur.numero_contrat_base,
                numero_contrat_option: response.data.decesEmployeur.numero_contrat_option,
                famille_produit_id_contrat_base: response.data.decesEmployeur.famille_produit_id_base,
                famille_produit_id_contrat_option: response.data.decesEmployeur.famille_produit_id_option,
                statut_assure: response.data.decesEmployeur.statut_assure,
                has_tb_mederic: response.data.decesEmployeur.has_tb_mederic === true ? 'true' : (response.data.decesEmployeur.has_tb_mederic === false ? 'false' : '')
              }
              this.$swal({
                position: 'top',
                type:'success',
                title:'Succès !',
                text: 'Employeur correctement ajouté.',
                showConfirmButton: false,
                timer: 5000
              });
              this.closeModalAddEmployeur();
            })
            .catch((error) => {
              console.log(error)
              let errorText = 'Une erreur est survenue lors de l\'enregistrement de l\'employeur. Si le problème persiste, merci de faire un ticket au support DOSI.'
              self.$swal({
                position: 'top',
                type:'error',
                title:'Attention !!',
                text:errorText,
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      validateAddEmployeur() {
        let valid = true;
        let fullNic = String(this.nic_employeur).padStart(5, '0');
        if (!checkSIRET(this.siren_employeur + fullNic)) {
          valid = false;
          this.errors.siren_employeur = 'Vous devez saisir un SIRET valide';
        }
        return valid;
      },
      checkSiretNouveauContrat() {
        let fullNic = String(this.nic_nouveau_contrat).padStart(5, '0');
        if (!checkSIRET(this.siren_nouveau_contrat + fullNic)) {
          this.errors.siren_nouveau_contrat = 'Vous devez saisir un SIRET valide';
        } else {
          this.errors.siren_nouveau_contrat = '';
        }
        // console.log('checkSIRET(this.siren_nouveau_contrat + fullNic)',checkSIRET(this.siren_nouveau_contrat + fullNic))
      },
      removeEmployeur(employeurId) {
        let self = this;
        
        this.$axios
          .delete("/espaceGestion/dossier/employeur/delete/"+employeurId)
          .then(response => {
            // Comme myData.decesEmployeurs est un objet et non un tableau, on ne peut pas utiliser .filter() ni for of
            let newObjectEmployeur = {};
            for (let id in this.myData.decesEmployeurs) {
              if (id !== employeurId) {
                newObjectEmployeur[id] = this.myData.decesEmployeurs[id];
              }
            }
            this.myData.decesEmployeurs = newObjectEmployeur;
            this.$swal({
              position: 'top',
              type:'success',
              title:'Succès !',
              text: 'Employeur correctement supprimé.',
              showConfirmButton: false,
              timer: 5000
            });
          })
          .catch((error) => {
            console.log(error)
            let errorText = 'Une erreur est survenue lors de la suppression de l\'employeur. Si le problème persiste, merci de faire un ticket au support DOSI.'
            self.$swal({
              position: 'top',
              type:'error',
              title:'Attention !!',
              text:errorText,
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      editEmployeur(employeur, employeurId) {
        let self = this;
        let dataPost = {
          employeurId: employeurId,
          employeur: employeur,
        }
        this.$axios
          .post("/espaceGestion/dossier/employeur/edit", dataPost)
          .then(response => {
            this.$swal({
              position: 'top',
              type:'success',
              title:'Succès !',
              text: 'Employeur correctement modifié.',
              showConfirmButton: false,
              timer: 5000
            });
            this.closeModalAddEmployeur();
          })
          .catch((error) => {
            console.log(error)
            let errorText = 'Une erreur est survenue lors de l\'enregistrement de l\'employeur. Si le problème persiste, merci de faire un ticket au support DOSI.'
            self.$swal({
              position: 'top',
              type:'error',
              title:'Attention !!',
              text:errorText,
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      save() {
        this.$parent.$parent.$parent.save('save');
      },
    }
  }
</script>
<style type="text/css">
  #stacked-checkbox-group .custom-checkbox {
    display: block !important;
  }
</style>